<div class="pill-container">
  <ng-content></ng-content>
  <i nz-icon type="close" title="Remove filter" theme="outline" (click)="removed.emit()"></i>
</div>
